<template>
  <table>
    <tr>
      <td>
        <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="getDate" prepend-icon="event" readonly style="width: 120px;" v-on="on" :disabled="disabled"></v-text-field>
          </template>
          <v-date-picker v-model="datePicker" @input="dateSet"></v-date-picker>
        </v-menu>
      </td>
      <td style="padding-left: 25px;">
        <v-menu v-model="timeMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="time" prepend-icon="access_time" readonly style="width: 85px" v-on="on" :disabled="disabled"></v-text-field>
          </template>
          <v-time-picker v-if="timeMenu" v-model="time" :allowed-minutes="allowedMinutes" class="mt-3" format="24hr" @click:minute="updateDate"></v-time-picker>
        </v-menu>
      </td>
      <td style="padding: 3px 10px; vertical-align: top;">
        <v-icon size="16" @click="clearDate">delete</v-icon>
      </td>
    </tr>
  </table>
</template>

<script>
import DateUtil from '@/assets/javascript/dateutil'

export default {
  name: 'DateTime',
  props: {
    value: String,
    disabled: Boolean,
    allowedMinutes: Function
  },
  created: function () {
  },
  mounted: function () {
    this.date = DateUtil.datetimeToDate(this.value)
    this.datePicker = this.date
    this.time = DateUtil.datetimeToTime(this.value)
  },
  data () {
    return {
      dateMenu: false,
      timeMenu: false,
      date: '',
      datePicker: '',
      dateNotSaved: false,
      time: ''
    }
  },
  computed: {
    getDate () {
      return this.dateNotSaved ? '' : this.date + ''
    }
  },
  methods: {
    allowedSteps: m => m % 5 === 0,
    dateSet (value) {
      this.dateMenu = false
      this.date = value
      this.dateNotSaved = false
    },
    clearDate () {
      this.date = ''
      this.datePicker = ''
      this.time = ''
      this.updateDate()
    },
    updateDate () {
      this.timeMenu = false
      this.$emit('updateDate', this.date + ' ' + this.time)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DateTime.vue